var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 88,
    viewBox: "0 0 132 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1 0H119.9C119.9 6.68265 125.317 12.1 132 12.1V75.9C125.317 75.9 119.9 81.3174 119.9 88H14.7529H12.1C12.1 81.3174 6.68265 75.9 0 75.9V56.9412V12.1C6.68265 12.1 12.1 6.68265 12.1 0Z",
    fill: "#F1F1FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.917 10.667L112.917 10.6669L112.917 8.66699H110.917V10.667ZM21.0839 10.667V8.66699H19.084L19.0839 10.6669L21.0839 10.667ZM120.966 19.8333L122.959 19.6688L122.808 17.8389L120.972 17.8333L120.966 19.8333ZM120.966 68.167L120.972 70.167L122.808 70.1614L122.959 68.3315L120.966 68.167ZM110.917 77.3337V79.3337H112.917V77.3337H110.917ZM21.0839 77.3337H19.0839V79.3337H21.0839V77.3337ZM11.0342 68.167L9.041 68.3315L9.19199 70.1616L11.0283 70.167L11.0342 68.167ZM11.0343 19.8333L11.0283 17.8333L9.19208 17.8387L9.04104 19.6688L11.0343 19.8333ZM110.917 8.66699H21.0839V12.667H110.917V8.66699ZM120.972 17.8333C116.338 17.819 112.917 14.442 112.917 10.6669L108.917 10.6671C108.917 16.9957 114.488 21.8134 120.96 21.8333L120.972 17.8333ZM123 20.667C123 20.3312 122.986 19.9983 122.959 19.6688L118.973 19.9978C118.991 20.2181 119 20.4412 119 20.667H123ZM123 67.3337V20.667H119V67.3337H123ZM122.959 68.3315C122.986 68.0021 123 67.6692 123 67.3337H119C119 67.5594 118.991 67.7824 118.973 68.0026L122.959 68.3315ZM112.917 77.3337C112.917 73.5584 116.338 70.1813 120.972 70.167L120.96 66.1671C114.488 66.187 108.917 71.0048 108.917 77.3337H112.917ZM23.2941 79.3337H110.917V75.3337H23.2941V79.3337ZM21.0839 79.3337H23.2941V75.3337H21.0839V79.3337ZM11.0283 70.167C15.6627 70.1808 19.0839 73.5582 19.0839 77.3337H23.0839C23.0839 71.0043 17.5126 66.1863 11.0402 66.167L11.0283 70.167ZM9 67.3337C9 67.6693 9.01383 68.0021 9.041 68.3315L13.0275 68.0026C13.0093 67.7824 13 67.5594 13 67.3337H9ZM9 53.8042V67.3337H13V53.8042H9ZM9 20.667V53.8042H13V20.667H9ZM9.04104 19.6688C9.01384 19.9983 9 20.3313 9 20.667H13C13 20.4412 13.0093 20.218 13.0275 19.9978L9.04104 19.6688ZM19.0839 10.6669C19.0838 14.4423 15.6626 17.8195 11.0283 17.8333L11.0402 21.8333C17.5125 21.814 23.0837 16.9962 23.0839 10.6671L19.0839 10.6669Z",
    fill: "#DDDDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.2852 33H103.571",
    stroke: "#6C6D8A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.2852 55.8564H84.1423",
    stroke: "#6C6D8A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.2852 44.4277H111.571",
    stroke: "#6C6D8A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 44H49",
    stroke: "#DDDDED",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34V54",
    stroke: "#DDDDED",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.9c8a1032ae57bc8a7d7feaf018bcd75c.svg";
export { ForwardRef as ReactComponent };